import * as constants from './actions';

import { getTimeFrom, getInitiatedTime } from '../../utils/actionTiming';

const initialState = {
    actionInitiated: false,
    showAddressPopup: false,
    showErrorPopup: false,
    isAddressSubmitting: false,
    isPostalCodeChanged: false,
    isRegisterOnlineSubmitting: false,
    isFormSubmitting: false,
    isSubmitting: false,
    isBackTransition: false,
    isErrorOnSubmit: false
};

export default function registerForVote(state = initialState, { type, payload }) {
    switch (type) {
        case constants.VOTE_REGISTRATION_INITIATED:
            return {
                ...state,
                ...getInitiatedTime(payload, state),
                actionInitiated: true
            };
        case constants.SET_SUCCESS_INFO_VOTE:
            return {
                ...state,
                completeVoteRegistration: {
                    ...state.completeVoteRegistration,
                    ...payload
                },
                successInfo: {
                    reason: payload.reason
                },
                actionIdentifier:
                    state.actionIdentifier !== undefined
                        ? [...state.actionIdentifier, payload.actionIdentifier]
                        : [payload.actionIdentifier]
            };
        case constants.VOTE_REGISTRATION_UNSUCCESS:
            return {
                ...state,
                isAddressSubmitting: payload.isAddressSubmitting,
                isErrorOnSubmit: payload.isErrorOnSubmit
            };
        case constants.VOTE_REGISTRATION_REGISTER_ONLINE:
            return {
                ...state,
                isRegisterOnlineSubmitting: payload.isRegisterOnlineSubmitting
            };
        case constants.VOTE_REGISTRATION_SUCCESS:
            return {
                ...state,
                isFormSubmitting: payload.isFormSubmitting
            };
        case constants.VOTE_REGISTRATION_COMPLETED:
            return {
                ...state,
                actionCompletionTime: getTimeFrom(
                    Object.values(getInitiatedTime(payload, state))[0]
                )
            };
        case constants.VOTE_REGISTRATION_CANCELED:
            return {
                ...state,
                actionCancelled: true,
                actionCancelledTime: getTimeFrom(
                    Object.values(getInitiatedTime(payload, state))[0]
                )
            };
        case constants.SET_DATE:
            return {
                ...state,
                dateOfBirth: {
                    month: payload.month,
                    day: payload.day,
                    year: payload.year
                }
            };
        case constants.SHOW_ADDRESS_POPUP:
            return {
                ...state,
                showAddressPopup: payload
            };
        case constants.SHOW_ERROR_POPUP:
            return {
                ...state,
                errorInfo: payload
            };
        case constants.ON_POSTAL_CODE_CHANGE:
            return {
                ...state,
                isPostalCodeChanged: payload
            };
        case constants.SAVE_FORM:
            return {
                ...state,
                formData: { ...state.formData, ...payload }
            };
        case constants.IS_SUBMITTING:
            return {
                ...state,
                isSubmitting: payload
            };
        case constants.IS_BACK_TRANSITION:
            return {
                ...state,
                isBackTransition: payload
            };
        default:
            return state;
    }
}
